module.exports = __webpack_public_path__ + "static/media/termin.307b4146.svg";